/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateImportDto,
  ImportListItemDto,
  ImportResponseDto,
  ImportsControllerCreateImportParams,
  ImportsControllerLatestMappingParams,
  ImportsControllerListImportsParams,
  LatestMappingResponseDto,
  UpdateImportMappingDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Accepts a spreadsheet (.xlsx/.xls/.csv) plus a column mapping, stores the file, and enqueues a BullMQ job to apply it server-side. partner_id is supplied in the query string because the multipart body is not parsed until after the guards run.
 * @summary Create an uploaded import
 */
export type importsControllerCreateImportResponse201 = {
  data: ImportResponseDto
  status: 201
}

export type importsControllerCreateImportResponse400 = {
  data: void
  status: 400
}

export type importsControllerCreateImportResponse401 = {
  data: void
  status: 401
}
    
export type importsControllerCreateImportResponseSuccess = (importsControllerCreateImportResponse201) & {
  headers: Headers;
};
export type importsControllerCreateImportResponseError = (importsControllerCreateImportResponse400 | importsControllerCreateImportResponse401) & {
  headers: Headers;
};

export type importsControllerCreateImportResponse = (importsControllerCreateImportResponseSuccess | importsControllerCreateImportResponseError)

export const getImportsControllerCreateImportUrl = (params: ImportsControllerCreateImportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/imports?${stringifiedParams}` : `/imports`
}

export const importsControllerCreateImport = async (createImportDto: CreateImportDto,
    params: ImportsControllerCreateImportParams, options?: RequestInit): Promise<importsControllerCreateImportResponse> => {
    const formData = new FormData();
if(createImportDto.project_id !== undefined) {
 formData.append(`project_id`, createImportDto.project_id)
 }
createImportDto.mapping.forEach(value => formData.append(`mapping`, JSON.stringify(value)));
if(createImportDto.source !== undefined) {
 formData.append(`source`, createImportDto.source)
 }

  return customFetch<importsControllerCreateImportResponse>(getImportsControllerCreateImportUrl(params),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getImportsControllerCreateImportMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsControllerCreateImport>>, TError,{data: CreateImportDto;params: ImportsControllerCreateImportParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importsControllerCreateImport>>, TError,{data: CreateImportDto;params: ImportsControllerCreateImportParams}, TContext> => {

const mutationKey = ['importsControllerCreateImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importsControllerCreateImport>>, {data: CreateImportDto;params: ImportsControllerCreateImportParams}> = (props) => {
          const {data,params} = props ?? {};

          return  importsControllerCreateImport(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportsControllerCreateImportMutationResult = NonNullable<Awaited<ReturnType<typeof importsControllerCreateImport>>>
    export type ImportsControllerCreateImportMutationBody = CreateImportDto
    export type ImportsControllerCreateImportMutationError = void

    /**
 * @summary Create an uploaded import
 */
export const useImportsControllerCreateImport = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsControllerCreateImport>>, TError,{data: CreateImportDto;params: ImportsControllerCreateImportParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importsControllerCreateImport>>,
        TError,
        {data: CreateImportDto;params: ImportsControllerCreateImportParams},
        TContext
      > => {

      const mutationOptions = getImportsControllerCreateImportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns imports for the partner, most-recent first. Optionally filter by status.
 * @summary List imports
 */
export type importsControllerListImportsResponse200 = {
  data: ImportListItemDto[]
  status: 200
}
    
export type importsControllerListImportsResponseSuccess = (importsControllerListImportsResponse200) & {
  headers: Headers;
};
;

export type importsControllerListImportsResponse = (importsControllerListImportsResponseSuccess)

export const getImportsControllerListImportsUrl = (params: ImportsControllerListImportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/imports?${stringifiedParams}` : `/imports`
}

export const importsControllerListImports = async (params: ImportsControllerListImportsParams, options?: RequestInit): Promise<importsControllerListImportsResponse> => {
  
  return customFetch<importsControllerListImportsResponse>(getImportsControllerListImportsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImportsControllerListImportsQueryKey = (params?: ImportsControllerListImportsParams,) => {
    return [
    `/imports`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getImportsControllerListImportsQueryOptions = <TData = Awaited<ReturnType<typeof importsControllerListImports>>, TError = unknown>(params: ImportsControllerListImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImportsControllerListImportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof importsControllerListImports>>> = ({ signal }) => importsControllerListImports(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ImportsControllerListImportsQueryResult = NonNullable<Awaited<ReturnType<typeof importsControllerListImports>>>
export type ImportsControllerListImportsQueryError = unknown


export function useImportsControllerListImports<TData = Awaited<ReturnType<typeof importsControllerListImports>>, TError = unknown>(
 params: ImportsControllerListImportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof importsControllerListImports>>,
          TError,
          Awaited<ReturnType<typeof importsControllerListImports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerListImports<TData = Awaited<ReturnType<typeof importsControllerListImports>>, TError = unknown>(
 params: ImportsControllerListImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof importsControllerListImports>>,
          TError,
          Awaited<ReturnType<typeof importsControllerListImports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerListImports<TData = Awaited<ReturnType<typeof importsControllerListImports>>, TError = unknown>(
 params: ImportsControllerListImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List imports
 */

export function useImportsControllerListImports<TData = Awaited<ReturnType<typeof importsControllerListImports>>, TError = unknown>(
 params: ImportsControllerListImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getImportsControllerListImportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List imports
 */
export const prefetchImportsControllerListImportsQuery = async <TData = Awaited<ReturnType<typeof importsControllerListImports>>, TError = unknown>(
 queryClient: QueryClient, params: ImportsControllerListImportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getImportsControllerListImportsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getImportsControllerListImportsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof importsControllerListImports>>, TError = unknown>(params: ImportsControllerListImportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImportsControllerListImportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof importsControllerListImports>>> = ({ signal }) => importsControllerListImports(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ImportsControllerListImportsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof importsControllerListImports>>>
export type ImportsControllerListImportsSuspenseQueryError = unknown


export function useImportsControllerListImportsSuspense<TData = Awaited<ReturnType<typeof importsControllerListImports>>, TError = unknown>(
 params: ImportsControllerListImportsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerListImportsSuspense<TData = Awaited<ReturnType<typeof importsControllerListImports>>, TError = unknown>(
 params: ImportsControllerListImportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerListImportsSuspense<TData = Awaited<ReturnType<typeof importsControllerListImports>>, TError = unknown>(
 params: ImportsControllerListImportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List imports
 */

export function useImportsControllerListImportsSuspense<TData = Awaited<ReturnType<typeof importsControllerListImports>>, TError = unknown>(
 params: ImportsControllerListImportsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerListImports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getImportsControllerListImportsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The most recent prior import's non-empty mapping, or [] when the partner has none. Pass status=success to copy the mapping from the most recent successful import.
 * @summary Get the partner template mapping
 */
export type importsControllerLatestMappingResponse200 = {
  data: LatestMappingResponseDto
  status: 200
}
    
export type importsControllerLatestMappingResponseSuccess = (importsControllerLatestMappingResponse200) & {
  headers: Headers;
};
;

export type importsControllerLatestMappingResponse = (importsControllerLatestMappingResponseSuccess)

export const getImportsControllerLatestMappingUrl = (params: ImportsControllerLatestMappingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/imports/latest-mapping?${stringifiedParams}` : `/imports/latest-mapping`
}

export const importsControllerLatestMapping = async (params: ImportsControllerLatestMappingParams, options?: RequestInit): Promise<importsControllerLatestMappingResponse> => {
  
  return customFetch<importsControllerLatestMappingResponse>(getImportsControllerLatestMappingUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImportsControllerLatestMappingQueryKey = (params?: ImportsControllerLatestMappingParams,) => {
    return [
    `/imports/latest-mapping`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getImportsControllerLatestMappingQueryOptions = <TData = Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError = unknown>(params: ImportsControllerLatestMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImportsControllerLatestMappingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof importsControllerLatestMapping>>> = ({ signal }) => importsControllerLatestMapping(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ImportsControllerLatestMappingQueryResult = NonNullable<Awaited<ReturnType<typeof importsControllerLatestMapping>>>
export type ImportsControllerLatestMappingQueryError = unknown


export function useImportsControllerLatestMapping<TData = Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError = unknown>(
 params: ImportsControllerLatestMappingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof importsControllerLatestMapping>>,
          TError,
          Awaited<ReturnType<typeof importsControllerLatestMapping>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerLatestMapping<TData = Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError = unknown>(
 params: ImportsControllerLatestMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof importsControllerLatestMapping>>,
          TError,
          Awaited<ReturnType<typeof importsControllerLatestMapping>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerLatestMapping<TData = Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError = unknown>(
 params: ImportsControllerLatestMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get the partner template mapping
 */

export function useImportsControllerLatestMapping<TData = Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError = unknown>(
 params: ImportsControllerLatestMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getImportsControllerLatestMappingQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get the partner template mapping
 */
export const prefetchImportsControllerLatestMappingQuery = async <TData = Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError = unknown>(
 queryClient: QueryClient, params: ImportsControllerLatestMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getImportsControllerLatestMappingQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getImportsControllerLatestMappingSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError = unknown>(params: ImportsControllerLatestMappingParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImportsControllerLatestMappingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof importsControllerLatestMapping>>> = ({ signal }) => importsControllerLatestMapping(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ImportsControllerLatestMappingSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof importsControllerLatestMapping>>>
export type ImportsControllerLatestMappingSuspenseQueryError = unknown


export function useImportsControllerLatestMappingSuspense<TData = Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError = unknown>(
 params: ImportsControllerLatestMappingParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerLatestMappingSuspense<TData = Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError = unknown>(
 params: ImportsControllerLatestMappingParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerLatestMappingSuspense<TData = Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError = unknown>(
 params: ImportsControllerLatestMappingParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get the partner template mapping
 */

export function useImportsControllerLatestMappingSuspense<TData = Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError = unknown>(
 params: ImportsControllerLatestMappingParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerLatestMapping>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getImportsControllerLatestMappingSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get an import
 */
export type importsControllerGetImportResponse200 = {
  data: ImportResponseDto
  status: 200
}

export type importsControllerGetImportResponse404 = {
  data: void
  status: 404
}
    
export type importsControllerGetImportResponseSuccess = (importsControllerGetImportResponse200) & {
  headers: Headers;
};
export type importsControllerGetImportResponseError = (importsControllerGetImportResponse404) & {
  headers: Headers;
};

export type importsControllerGetImportResponse = (importsControllerGetImportResponseSuccess | importsControllerGetImportResponseError)

export const getImportsControllerGetImportUrl = (importId: string,) => {


  

  return `/imports/${importId}`
}

export const importsControllerGetImport = async (importId: string, options?: RequestInit): Promise<importsControllerGetImportResponse> => {
  
  return customFetch<importsControllerGetImportResponse>(getImportsControllerGetImportUrl(importId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImportsControllerGetImportQueryKey = (importId?: string,) => {
    return [
    `/imports/${importId}`
    ] as const;
    }

    
export const getImportsControllerGetImportQueryOptions = <TData = Awaited<ReturnType<typeof importsControllerGetImport>>, TError = void>(importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImportsControllerGetImportQueryKey(importId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof importsControllerGetImport>>> = ({ signal }) => importsControllerGetImport(importId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(importId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ImportsControllerGetImportQueryResult = NonNullable<Awaited<ReturnType<typeof importsControllerGetImport>>>
export type ImportsControllerGetImportQueryError = void


export function useImportsControllerGetImport<TData = Awaited<ReturnType<typeof importsControllerGetImport>>, TError = void>(
 importId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof importsControllerGetImport>>,
          TError,
          Awaited<ReturnType<typeof importsControllerGetImport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerGetImport<TData = Awaited<ReturnType<typeof importsControllerGetImport>>, TError = void>(
 importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof importsControllerGetImport>>,
          TError,
          Awaited<ReturnType<typeof importsControllerGetImport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerGetImport<TData = Awaited<ReturnType<typeof importsControllerGetImport>>, TError = void>(
 importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get an import
 */

export function useImportsControllerGetImport<TData = Awaited<ReturnType<typeof importsControllerGetImport>>, TError = void>(
 importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getImportsControllerGetImportQueryOptions(importId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get an import
 */
export const prefetchImportsControllerGetImportQuery = async <TData = Awaited<ReturnType<typeof importsControllerGetImport>>, TError = void>(
 queryClient: QueryClient, importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getImportsControllerGetImportQueryOptions(importId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getImportsControllerGetImportSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof importsControllerGetImport>>, TError = void>(importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImportsControllerGetImportQueryKey(importId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof importsControllerGetImport>>> = ({ signal }) => importsControllerGetImport(importId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ImportsControllerGetImportSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof importsControllerGetImport>>>
export type ImportsControllerGetImportSuspenseQueryError = void


export function useImportsControllerGetImportSuspense<TData = Awaited<ReturnType<typeof importsControllerGetImport>>, TError = void>(
 importId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerGetImportSuspense<TData = Awaited<ReturnType<typeof importsControllerGetImport>>, TError = void>(
 importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerGetImportSuspense<TData = Awaited<ReturnType<typeof importsControllerGetImport>>, TError = void>(
 importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get an import
 */

export function useImportsControllerGetImportSuspense<TData = Awaited<ReturnType<typeof importsControllerGetImport>>, TError = void>(
 importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerGetImport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getImportsControllerGetImportSuspenseQueryOptions(importId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Replaces the stored mapping. Does not re-run the import — use retry for that.
 * @summary Update an import mapping
 */
export type importsControllerUpdateMappingResponse200 = {
  data: ImportResponseDto
  status: 200
}

export type importsControllerUpdateMappingResponse404 = {
  data: void
  status: 404
}
    
export type importsControllerUpdateMappingResponseSuccess = (importsControllerUpdateMappingResponse200) & {
  headers: Headers;
};
export type importsControllerUpdateMappingResponseError = (importsControllerUpdateMappingResponse404) & {
  headers: Headers;
};

export type importsControllerUpdateMappingResponse = (importsControllerUpdateMappingResponseSuccess | importsControllerUpdateMappingResponseError)

export const getImportsControllerUpdateMappingUrl = (importId: string,) => {


  

  return `/imports/${importId}/mapping`
}

export const importsControllerUpdateMapping = async (importId: string,
    updateImportMappingDto: UpdateImportMappingDto, options?: RequestInit): Promise<importsControllerUpdateMappingResponse> => {
  
  return customFetch<importsControllerUpdateMappingResponse>(getImportsControllerUpdateMappingUrl(importId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateImportMappingDto,)
  }
);}




export const getImportsControllerUpdateMappingMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsControllerUpdateMapping>>, TError,{importId: string;data: UpdateImportMappingDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importsControllerUpdateMapping>>, TError,{importId: string;data: UpdateImportMappingDto}, TContext> => {

const mutationKey = ['importsControllerUpdateMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importsControllerUpdateMapping>>, {importId: string;data: UpdateImportMappingDto}> = (props) => {
          const {importId,data} = props ?? {};

          return  importsControllerUpdateMapping(importId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportsControllerUpdateMappingMutationResult = NonNullable<Awaited<ReturnType<typeof importsControllerUpdateMapping>>>
    export type ImportsControllerUpdateMappingMutationBody = UpdateImportMappingDto
    export type ImportsControllerUpdateMappingMutationError = void

    /**
 * @summary Update an import mapping
 */
export const useImportsControllerUpdateMapping = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsControllerUpdateMapping>>, TError,{importId: string;data: UpdateImportMappingDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importsControllerUpdateMapping>>,
        TError,
        {importId: string;data: UpdateImportMappingDto},
        TContext
      > => {

      const mutationOptions = getImportsControllerUpdateMappingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Resets the import to pending, clears prior results, and re-enqueues the apply job.
 * @summary Retry an import
 */
export type importsControllerRetryResponse202 = {
  data: ImportResponseDto
  status: 202
}

export type importsControllerRetryResponse404 = {
  data: void
  status: 404
}
    
export type importsControllerRetryResponseSuccess = (importsControllerRetryResponse202) & {
  headers: Headers;
};
export type importsControllerRetryResponseError = (importsControllerRetryResponse404) & {
  headers: Headers;
};

export type importsControllerRetryResponse = (importsControllerRetryResponseSuccess | importsControllerRetryResponseError)

export const getImportsControllerRetryUrl = (importId: string,) => {


  

  return `/imports/${importId}/retry`
}

export const importsControllerRetry = async (importId: string, options?: RequestInit): Promise<importsControllerRetryResponse> => {
  
  return customFetch<importsControllerRetryResponse>(getImportsControllerRetryUrl(importId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getImportsControllerRetryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsControllerRetry>>, TError,{importId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importsControllerRetry>>, TError,{importId: string}, TContext> => {

const mutationKey = ['importsControllerRetry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importsControllerRetry>>, {importId: string}> = (props) => {
          const {importId} = props ?? {};

          return  importsControllerRetry(importId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportsControllerRetryMutationResult = NonNullable<Awaited<ReturnType<typeof importsControllerRetry>>>
    
    export type ImportsControllerRetryMutationError = void

    /**
 * @summary Retry an import
 */
export const useImportsControllerRetry = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsControllerRetry>>, TError,{importId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importsControllerRetry>>,
        TError,
        {importId: string},
        TContext
      > => {

      const mutationOptions = getImportsControllerRetryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Streams the originally uploaded spreadsheet as an attachment.
 * @summary Download the stored import file
 */
export type importsControllerDownloadFileResponse200 = {
  data: void
  status: 200
}

export type importsControllerDownloadFileResponse404 = {
  data: void
  status: 404
}
    
export type importsControllerDownloadFileResponseSuccess = (importsControllerDownloadFileResponse200) & {
  headers: Headers;
};
export type importsControllerDownloadFileResponseError = (importsControllerDownloadFileResponse404) & {
  headers: Headers;
};

export type importsControllerDownloadFileResponse = (importsControllerDownloadFileResponseSuccess | importsControllerDownloadFileResponseError)

export const getImportsControllerDownloadFileUrl = (importId: string,) => {


  

  return `/imports/${importId}/file`
}

export const importsControllerDownloadFile = async (importId: string, options?: RequestInit): Promise<importsControllerDownloadFileResponse> => {
  
  return customFetch<importsControllerDownloadFileResponse>(getImportsControllerDownloadFileUrl(importId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getImportsControllerDownloadFileQueryKey = (importId?: string,) => {
    return [
    `/imports/${importId}/file`
    ] as const;
    }

    
export const getImportsControllerDownloadFileQueryOptions = <TData = Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError = void>(importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImportsControllerDownloadFileQueryKey(importId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof importsControllerDownloadFile>>> = ({ signal }) => importsControllerDownloadFile(importId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(importId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ImportsControllerDownloadFileQueryResult = NonNullable<Awaited<ReturnType<typeof importsControllerDownloadFile>>>
export type ImportsControllerDownloadFileQueryError = void


export function useImportsControllerDownloadFile<TData = Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError = void>(
 importId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof importsControllerDownloadFile>>,
          TError,
          Awaited<ReturnType<typeof importsControllerDownloadFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerDownloadFile<TData = Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError = void>(
 importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof importsControllerDownloadFile>>,
          TError,
          Awaited<ReturnType<typeof importsControllerDownloadFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerDownloadFile<TData = Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError = void>(
 importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Download the stored import file
 */

export function useImportsControllerDownloadFile<TData = Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError = void>(
 importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getImportsControllerDownloadFileQueryOptions(importId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Download the stored import file
 */
export const prefetchImportsControllerDownloadFileQuery = async <TData = Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError = void>(
 queryClient: QueryClient, importId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getImportsControllerDownloadFileQueryOptions(importId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getImportsControllerDownloadFileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError = void>(importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImportsControllerDownloadFileQueryKey(importId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof importsControllerDownloadFile>>> = ({ signal }) => importsControllerDownloadFile(importId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ImportsControllerDownloadFileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof importsControllerDownloadFile>>>
export type ImportsControllerDownloadFileSuspenseQueryError = void


export function useImportsControllerDownloadFileSuspense<TData = Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError = void>(
 importId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerDownloadFileSuspense<TData = Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError = void>(
 importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useImportsControllerDownloadFileSuspense<TData = Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError = void>(
 importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Download the stored import file
 */

export function useImportsControllerDownloadFileSuspense<TData = Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError = void>(
 importId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof importsControllerDownloadFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getImportsControllerDownloadFileSuspenseQueryOptions(importId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




